const DESKTOP = window.matchMedia('(min-width: 990px)');
const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

class LucidFooterNav extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('details[data-lucid-footer-group]')];
    this.sync = this.sync.bind(this);
    this.guard = this.guard.bind(this);
    this.items.forEach((item) => item.querySelector('summary')?.addEventListener('click', this.guard));
    DESKTOP.addEventListener('change', this.sync);
    this.sync();
  }

  disconnectedCallback() {
    DESKTOP.removeEventListener('change', this.sync);
    this.items?.forEach((item) => item.querySelector('summary')?.removeEventListener('click', this.guard));
  }

  sync() {
    this.items.forEach((item) => {
      item.open = DESKTOP.matches;
      const summary = item.querySelector('summary');
      if (!summary) return;
      if (DESKTOP.matches) {
        summary.setAttribute('tabindex', '-1');
        summary.setAttribute('aria-disabled', 'true');
      } else {
        summary.removeAttribute('tabindex');
        summary.removeAttribute('aria-disabled');
      }
    });
  }

  guard(event) {
    if (DESKTOP.matches) event.preventDefault();
  }
}

class LucidFooterMark extends HTMLElement {
  connectedCallback() {
    if (REDUCED_MOTION.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    this.classList.add('is-armed');
    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.classList.add('is-in');
        this.observer?.disconnect();
      },
      { threshold: 0.2 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

class LucidLocalization extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLSelectElement)) return;
      const form = event.target.form;
      if (!form) return;
      form.setAttribute('aria-busy', 'true');
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  }
}

if (!customElements.get('lucid-footer-nav')) customElements.define('lucid-footer-nav', LucidFooterNav);
if (!customElements.get('lucid-footer-mark')) customElements.define('lucid-footer-mark', LucidFooterMark);
if (!customElements.get('lucid-localization')) customElements.define('lucid-localization', LucidLocalization);
